import { AuthStatus, useAuthContext } from '@space-shell/common/contexts/auth'
import useRequest from '@space-shell/common/hooks/useRequest'
import {
  GamificationEndpoints,
  GamificationService
} from '@space-shell/common/services/gamification'
import { useMembershipStore } from '@space-shell/core/store'

const useGamificationToggle = () => {
  const { membershipData } = useMembershipStore()
  const { authStatus } = useAuthContext()
  const isUserAuthenticated = Boolean(authStatus === AuthStatus.AUTHENTICATED)
  const membershipId = membershipData?.id || ''

  return useRequest(
    [GamificationEndpoints.gamificationToggle(membershipId)],
    () => GamificationService.getGamificationToggle(membershipId),
    { enabled: Boolean(membershipId && isUserAuthenticated) }
  )
}

export default useGamificationToggle
